<script setup>
import { DmButton, DmCountrySelect, DmIndustrySelect, MultiSelectDropdown } from 'dmui_components'
import { computed } from 'vue'
import ReportSortMenu from '../ReportSortMenu.vue'
import useReportTypeMgmt from '../composables/useReportTypeMgmt.js'
import ReportRepository from '../repository/ReportRepository.js'

const { getReportTypes } = useReportTypeMgmt()

const props = defineProps({
	filters: {
		type: Object,
		default: () => ({})
	},
	order: {
		type: Object,
		default: () => ({})
	},
	readonly: {
		type: Boolean,
		default: false
	}
})
const emit = defineEmits(['update:filters', 'reset:filters', 'update:order'])
const yearFilterOptions = Array.from({ length: 10 }, (_, i) => ReportRepository.getLatestYear() - i)

const statusFilterOptions = ['Error', 'Processing', 'Done']

function onUpdateFilter(key, value) {
	emit('update:filters', { ...props.filters, [key]: value })
}

const filtersApplied = computed(() => Object.values(props.filters).flat().length > 0)
</script>
<template>
	<div class="filters-header">
		<MultiSelectDropdown id="document-type" :selected="filters.document_type" :options="getReportTypes()" label="Type" @update:selected="onUpdateFilter('document_type', $event)">
			<template #option="{ option }">{{ option?.charAt(0).toUpperCase() + option?.slice(1) }}</template>
		</MultiSelectDropdown>
		<MultiSelectDropdown id="document-year" :selected="filters.document_year" :options="yearFilterOptions" label="Year" @update:selected="onUpdateFilter('document_year', $event)">
			<template #option="{ option }">{{ option }}</template>
		</MultiSelectDropdown>
		<MultiSelectDropdown id="document-status" :selected="filters.status" :options="statusFilterOptions" label="Status" @update:selected="onUpdateFilter('status', $event)">
			<template #option="{ option }">{{ option }}</template>
		</MultiSelectDropdown>
		<DmCountrySelect
			id="document-country"
			:data="filters.country_name"
			:show-preview="false"
			placeholder="Country & region"
			@update:data="onUpdateFilter('country_name', $event)" />
		<DmIndustrySelect id="document-industry" :data="filters.industry_name" :show-preview="false" placeholder="Sector" @update:data="onUpdateFilter('industry_name', $event)" />
		<DmButton v-if="filtersApplied" id="clear-filters" class="transparent small" @click="$emit('reset:filters')">Clear all</DmButton>
		<ReportSortMenu :order="order" @update:order="$emit('update:order', $event)" />
		<DmButton v-if="!readonly" id="add-report" class="small" @click="$router.push('report/edit')">Add new</DmButton>
	</div>
</template>

<style scoped lang="less">
.filters-header {
	display: flex;
	gap: @micro;
	align-items: center;
	margin-bottom: @midi;
	&:last-child {
		margin-left: auto;
	}
}
</style>
